import React from 'react'
import cctvcamera from "../images/cctv-camera color.png";
import electricity from "../images/Electricity Line Ready.jpg";
import wallboundary from "../images/12 Feet Wall Boudary.jpg";


function OurFacility() {
    return (
        <div>
           
            <div className='album py-1'>
                <div className='container'>
                    <center><h1>SRG COMPLEX Facilities</h1></center>
                </div>
            </div>


            <div className='album py-3'>
                <div className='container'>
                    <div className='row'>
                       
                    
                      
                        <div className="col-md-3 mt-2">
                            <div className="card" >

                                <div className="card-body">
                                    <center>
                                   <svg xmlns="http://www.w3.org/2000/svg" style={{ color: "#B80000" }} width="66" height="66" fill="currentColor" class="bi bi-shield-fill-check" viewBox="0 0 16 16">
  <path fill-rule="evenodd" d="M8 0c-.69 0-1.843.265-2.928.56-1.11.3-2.229.655-2.887.87a1.54 1.54 0 0 0-1.044 1.262c-.596 4.477.787 7.795 2.465 9.99a11.8 11.8 0 0 0 2.517 2.453c.386.273.744.482 1.048.625.28.132.581.24.829.24s.548-.108.829-.24a7 7 0 0 0 1.048-.625 11.8 11.8 0 0 0 2.517-2.453c1.678-2.195 3.061-5.513 2.465-9.99a1.54 1.54 0 0 0-1.044-1.263 63 63 0 0 0-2.887-.87C9.843.266 8.69 0 8 0m2.146 5.146a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 7.793z"/>
</svg>
                                        <h4 className="card-text">24X7 Security</h4>

                                    </center>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3 mt-2">
                            <div className="card" >

                                <div className="card-body">
                                    <center>
    <svg xmlns="http://www.w3.org/2000/svg" style={{ color: "#B80000" }} width="66" height="66" fill="currentColor" class="bi bi-bank" viewBox="0 0 16 16">
  <path d="m8 0 6.61 3h.89a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5H15v7a.5.5 0 0 1 .485.38l.5 2a.498.498 0 0 1-.485.62H.5a.498.498 0 0 1-.485-.62l.5-2A.5.5 0 0 1 1 13V6H.5a.5.5 0 0 1-.5-.5v-2A.5.5 0 0 1 .5 3h.89zM3.777 3h8.447L8 1zM2 6v7h1V6zm2 0v7h2.5V6zm3.5 0v7h1V6zm2 0v7H12V6zM13 6v7h1V6zm2-1V4H1v1zm-.39 9H1.39l-.25 1h13.72z"/>
</svg>
                                        <h4 className="card-text">Bank Loan Available</h4>

                                    </center>
                                </div>
                            </div>
                        </div>
                            <div className="col-md-3 mt-2">
                            <div className="card" >

                                <div className="card-body">
                                    <center>
  <svg xmlns="http://www.w3.org/2000/svg" style={{ color: "#B80000" }}  width="66" height="66" fill="currentColor" class="bi bi-signpost-split" viewBox="0 0 16 16">
  <path d="M7 7V1.414a1 1 0 0 1 2 0V2h5a1 1 0 0 1 .8.4l.975 1.3a.5.5 0 0 1 0 .6L14.8 5.6a1 1 0 0 1-.8.4H9v10H7v-5H2a1 1 0 0 1-.8-.4L.225 9.3a.5.5 0 0 1 0-.6L1.2 7.4A1 1 0 0 1 2 7zm1 3V8H2l-.75 1L2 10zm0-5h6l.75-1L14 3H8z"/>
</svg>
                                        <h4 className="card-text">22 Feet Road</h4>

                                    </center>
                                </div>
                            </div>
                        </div>
                            <div className="col-md-3 mt-2">
                            <div className="card" >
                                <div className="card-body">
                                    <center>
                                                                                      <img src={cctvcamera} height="67px" width="76px" alt="cctvcamera"/>

                                        <h4 className="card-text">CC TV Camera</h4>

                                    </center>
                                </div>
                            </div>
                        </div>

                          <div className="col-md-3 mt-2">
                            <div className="card" >
                                <div className="card-body">
                                    <center>
                                                         <img src={electricity} height="67px" width="76px" alt="electricity avialable"/>

                                        <h4 className="card-text">Electricity </h4>

                                    </center>
                                </div>
                            </div>
                        </div>
                          <div className="col-md-3 mt-2">
                            <div className="card" >
                                <div className="card-body">
                                    <center>
                                        <img src={wallboundary} height="67px" width="76px" alt="wallboundary"/>

                                        <h4 className="card-text">12 Feet Boundary</h4>

                                    </center>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default OurFacility